import React from 'react';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { dcDueActions } from '_actions';

class DischargeDueListItem extends React.Component {
    render() {
        return (
            <div
                className={
                    this.props.id === this.props.selectedMessage ? messageCenterCommonStyles.selected_message :
                        this.props.message.isRead === true ? messageCenterCommonStyles.read_message : messageCenterCommonStyles.unread_message
                }
                onClick={() => this.props.changeMessage(this.props.id)}>
                {this.props.message.ptname}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        message: state.entities.dcDue[ownprops.id],
        selectedMessage: state.ui.dcDue.selectedMessage,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeMessage: bindActionCreators(dcDueActions.changeSelection, dispatch)
    };
}

const connectedDischargeDueListItem = connect(mapStateToProps, mapDispatchToProps)(DischargeDueListItem);
export { connectedDischargeDueListItem as DischargeDueListItem };